/** @jsx jsx */
import { React, jsx, css } from 'jimu-core';
function buildThresholdList() {
    const step = 10;
    const result = [0];
    for (let i = 1; i <= step; i++) {
        result.push(i / step);
    }
    return result;
}
export class ViewportIntersectionObserver extends React.PureComponent {
    constructor(props) {
        super(props);
        this.elemRef = React.createRef();
        this.handleIntersectionChange = this.handleIntersectionChange.bind(this);
    }
    handleIntersectionChange(entry) {
        if (entry.target.classList.contains('playing-animation')) {
            return;
        }
        this.props.onIntersectionChange(entry.isIntersecting);
    }
    componentDidMount() {
        if (this.elemRef.current) {
            const handler = (entries) => {
                this.handleIntersectionChange(entries[0]);
            };
            this.observer = new IntersectionObserver(handler, {
                threshold: buildThresholdList(),
                root: document
            });
            this.observer.observe(this.elemRef.current.parentNode);
        }
    }
    componentWillUnmount() {
        if (this.observer) {
            this.observer.unobserve(this.elemRef.current.parentNode);
            this.observer = null;
        }
    }
    render() {
        return (jsx("div", { ref: this.elemRef, css: css `
          display: none;
        ` }));
    }
}
